import { supabase } from './client'

export interface SupportEmailData {
  name: string
  email: string
  subject: string
  message: string
}

export interface EmailResponse {
  success: boolean
  message: string
  emailId?: string
  error?: string
  details?: string
}

export async function sendSupportEmail(data: SupportEmailData): Promise<EmailResponse> {
  try {
    console.log('Sending support email with data:', data);
    
    const { data: result, error } = await supabase.functions.invoke('send-support-email', {
      body: data,
    })

    console.log('Supabase function response:', { result, error });

    if (error) {
      console.error('Supabase function error:', error)
      return {
        success: false,
        error: 'Failed to send email',
        message: 'Please try again later or contact support directly at hello@fendly.org'
      }
    }

    return result as EmailResponse
  } catch (err) {
    console.error('Error calling send-support-email function:', err)
    return {
      success: false,
      error: 'Network error',
      message: 'Please check your connection and try again'
    }
  }
}
